import { Box, Card, CardBody, Flex, Image, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  subcopy: string;
  toggle?: ReactNode;
  children: ReactNode;
};

const DocumentsCardShell = ({ subcopy, toggle, children }: Props) => (
  <Card borderRadius="24px" p={2}>
    <Flex justify="space-between" align="center" px={2} py={2}>
      <Box>
        <Text
          fontSize={{ base: 'lg', md: 'xl' }}
          fontWeight="700"
          color="leaseEndBlue"
          letterSpacing="wider"
        >
          Documents
        </Text>
        <Text fontSize="md" color="gray.600" mt={1}>
          {subcopy}
        </Text>
      </Box>
      <Image src="/leaseend-com-images/license-plate.svg" alt="License plate" maxW="100px" ml={2} />
    </Flex>
    {toggle}
    <CardBody bgColor="grayCoolLight" borderRadius="16px">
      {children}
    </CardBody>
  </Card>
);

export default DocumentsCardShell;
